import Plyr from "plyr";
import {Modal} from "bootstrap";

const VideoPlayer = () => {

    const videoElement = document.querySelector('.video-player');

    //quality
    const sources = videoElement.querySelectorAll('source[size]');
    const qualityOptions = Array.from(sources).map(source => parseInt(source.getAttribute('size')));
    const qualityDefault = qualityOptions.includes(1080) ? 1080 : Math.max(...qualityOptions.filter(q => q < 1080));

    //init
    const player = new Plyr('.video-player', {
        invertTime: false,
        keyboard: {focused: false, global: true},
        quality: {
            autoplay: true,
            default: qualityDefault,
            options: qualityOptions,
        }
    });

    player.once('play', () => {
        const videoId = videoElement.getAttribute('data-id')
        if(videoId){
            const customerId = videoElement.getAttribute('data-customer-id')
            sendVideoPlay(videoId, customerId);
        }
    });


    const isTrailer = parseInt(videoElement.getAttribute('data-is-trailer'))
    if(!isTrailer){
        player.on('pause', () => {
            if (!player.seeking) {
                showRelatedVideos()
            }
        });
        player.on('play', () => {
            hideRelatedVideos()
        });

        const relatedVideosContainer = document.querySelector('.player-related-videos');
        if (relatedVideosContainer) {
            relatedVideosContainer.addEventListener('click', (event) => {
                if (event.target === relatedVideosContainer) {
                    player.play()
                }
            });
        }
    }
    else{
        player.on('timeupdate', () => {
            if(player.currentTime >= player.duration - 5 && player.currentTime <= player.duration - 4){
                showMembershipPopup()
            }
        });
        player.on('pause', () => {
            if (!player.seeking) {
                showMembershipPopup()
            }
        });
        player.on('play', () => {
            hideMembershipPopup()
        });

    }
}

const sendVideoPlay = (videoId, customerId) => {
    if(customerId){
        fetch(`/api/video/view/${videoId}?customerId=${customerId}`, {
            method: "GET",
        });
        return
    }
    fetch(`/api/video/view/${videoId}`, {
        method: "GET",
    });

};

const showMembershipPopup = () => {
    const element = document.querySelector('#get_membership_modal');
    if(element){
        let modal = Modal.getInstance(element);
        if (!modal) {
            modal = new Modal(element);
        }
        modal.show()
    }
}

const hideMembershipPopup = () => {
    const element = document.querySelector('#get_membership_modal');
    if(element){
        let modal = Modal.getInstance(element);
        if (!modal) {
            modal = new Modal(element);
        }
        modal.hide()
    }
}

const showRelatedVideos = () => {
    const relatedVideosContainer = document.querySelector('.player-related-videos');
    if(relatedVideosContainer && window.innerWidth > 768){
        relatedVideosContainer.style.removeProperty('display');
    }
}
const hideRelatedVideos = () => {
    const relatedVideosContainer = document.querySelector('.player-related-videos');
    if(relatedVideosContainer){
        relatedVideosContainer.style.display = 'none';
    }
}

export default VideoPlayer